/**
 * Utility function to retry failed requests that return 500 status code
 * @param {Function} requestFn - The request function to execute
 * @param {number} maxRetries - Maximum number of retry attempts
 * @param {number} delayMs - Delay between retries in milliseconds
 * @returns {Promise} - Returns the response from the request
 */
export const retryOn500 = async ({
    requestFn,
    maxRetries = 3,
    delayMs = 1000
  }) => {
    let attempts = 0;
  
    while (attempts < maxRetries) {
      try {
        return await requestFn();
      } catch (error) {
        attempts++;
        
        // Only retry on 500 status code
        if (error?.response?.status !== 500 || attempts >= maxRetries) {
          throw error;
        }
  
        // Add small random jitter (�100ms) to prevent thundering herd
        const jitter = Math.random() * 200 - 100;
        
        console.log(`Received 500 error, retrying in ${delayMs}ms... (Attempt ${attempts} of ${maxRetries})`);
        
        await new Promise(resolve => setTimeout(resolve, delayMs + jitter));
      }
    }
  };
  
  // You can also export default if preferred
  export default retryOn500;